const firebaseConfig = {
  //   apiKey: process.env.REACT_FIREBASE_APP_API_KEY,
  //   authDomain: process.env.REACT_FIREBASE_APP_AUTH_DOMAIN,
  //   projectId: process.env.REACT_FIREBASE_APP_PROJECT_ID,
  //   storageBucket: process.env.REACT_FIREBASE_APP_STORAGE_BUCKET,
  //   messagingSenderId: process.env.REACT_FIREBASE_APP_MESSAGING_SENDER_ID,
  //   appId: process.env.REACT_FIREBASE_APP_APP_ID,

  apiKey: "AIzaSyA7quEI6fpqbI_bV47iREZQZ3OFl5ykBgQ",
  authDomain: "pause-moments.firebaseapp.com",
  projectId: "pause-moments",
  storageBucket: "pause-moments.appspot.com",
  messagingSenderId: "860896020599",
  appId: "1:860896020599:web:020d03ae77c5490b041e",
};

export default firebaseConfig;
